import { ColumnActions, ColumnActionsEnum } from "../actions/columnActions";
import { columnsInitialState } from "./initialState";

const columnReducer = (
  state: State.ColumnMap = columnsInitialState,
  action: ColumnActions
): State.ColumnMap => {
  switch (action.type) {
    case ColumnActionsEnum.SET_HIDING_TEST_COLUMN_STATUS: {
      const { name, isVisible, activeSubmenu } = action.payload;
      let columns = state[activeSubmenu];
      columns = columns.map(column => {
        if (column.name === name) {
          return { ...column, isVisible };
        } else {
          return column;
        }
      });
      return {
        ...state,
        [activeSubmenu]: columns
      };
    }
    default:
      return state;
  }
};

export default columnReducer;
